module.exports = __webpack_public_path__ + "img/Deathknight-bloodelf-f-70.b5f00b65.gif";